import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Keunggulan = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <section
      className="py-8 bg-cover bg-center transition-colors duration-300 mb-20"
      style={{
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className={`text-4xl font-bold mb-4 ${isDarkMode ? 'text-green-50' : 'text-gray-900'}`}>
            Keunggulan Paket Internet Kami
          </h2>
          <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-lg max-w-3xl mx-auto`}>
            Setiap paket dirancang dengan teknologi terdepan dan fitur unggulan untuk memberikan pengalaman internet terbaik
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Unlimited Data */}
          <div
            className={`
              rounded-2xl p-6 text-center transition-all
              ${isDarkMode
                ? 'bg-gray-800 text-green-50 border border-gray-700 hover:bg-gray-750'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}
              hover:-translate-y-1 hover:shadow-xl ring-1 ring-black/0 hover:ring-black/5
            `}
          >
           <img src="/image/Unlimeted.png" className="mx-auto mb-4 w-90 h-90"></img> <h3 className="text-xl font-bold mb-3">Unlimited Data</h3> <p className="text-gray-400"> Nikmati internet tanpa batas kuota. Streaming, download, dan browsing sepuasnya tanpa khawatir data habis. </p> </div>

          {/* Free Installation */}
          <div
            className={`
              rounded-2xl p-6 text-center transition-all
              ${isDarkMode
                ? 'bg-gray-800 text-green-50 border border-gray-700 hover:bg-gray-750'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}
              hover:-translate-y-1 hover:shadow-xl ring-1 ring-black/0 hover:ring-black/5
            `}
          >
          <img src="/image/instalasi.png" alt="Free Installation" className="mx-auto mb-4 w-90 h-90" /> <h3 className="text-xl font-bold mb-3">Free Installation</h3> <p className="text-gray-400"> Pemasangan gratis untuk pelanggan baru dengan kontrak minimal 12 bulan. Hemat biaya instalasi hingga Rp 500.000. </p> </div>

          {/* Priority Support */}
          <div
            className={`
              rounded-2xl p-6 text-center transition-all
              ${isDarkMode
                ? 'bg-gray-800 text-green-50 border border-gray-700 hover:bg-gray-750'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}
              hover:-translate-y-1 hover:shadow-xl ring-1 ring-black/0 hover:ring-black/5
            `}
          >
            <img src="/image/priority.png" className="mx-auto mb-4 w-90 h-90"></img> <h3 className="text-xl font-bold mb-3">Priority Support</h3> <p className="text-gray-400"> Tim support khusus 24/7 untuk pelanggan premium dan bisnis. Response time cepat dan solusi tepat sasaran. </p> </div>

          {/* Free Router Premium */}
          <div
            className={`
              rounded-2xl p-6 text-center transition-all
              ${isDarkMode
                ? 'bg-gray-800 text-green-50 border border-gray-700 hover:bg-gray-750'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}
              hover:-translate-y-1 hover:shadow-xl ring-1 ring-black/0 hover:ring-black/5
            `}
          >
          <img src="/image/router.png" className="mx-auto mb-4 w-90 h-90"></img> <h3 className="text-xl font-bold mb-3">Unlimited Data</h3> <h3 className="text-xl font-bold mb-3">Free Router Premium</h3> <p className="text-gray-400"> Router WiFi 6 premium gratis untuk paket tertentu. Jangkauan luas dan koneksi stabil untuk semua device. </p> </div>

          {/* Gaming Optimization */}
          <div
            className={`
              rounded-2xl p-6 text-center transition-all
              ${isDarkMode
                ? 'bg-gray-800 text-green-50 border border-gray-700 hover:bg-gray-750'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}
              hover:-translate-y-1 hover:shadow-xl ring-1 ring-black/0 hover:ring-black/5
            `}
          >
          <img src="/image/gaming.png" className="mx-auto mb-4 w-90 h-90"></img> <h3 className="text-xl font-bold mb-3">Unlimited Data</h3> <h3 className="text-xl font-bold mb-3">Gaming Optimization</h3> <p className="text-gray-400"> Optimasi khusus untuk gaming dengan ping rendah &lt;10ms. QoS prioritas untuk traffic gaming dan streaming. </p> </div>

          {/* SLA 99.9% */}
          <div
            className={`
              rounded-2xl p-6 text-center transition-all
              ${isDarkMode
                ? 'bg-gray-800 text-green-50 border border-gray-700 hover:bg-gray-750'
                : 'bg-white text-gray-900 border border-gray-200 hover:bg-gray-50'}
              hover:-translate-y-1 hover:shadow-xl ring-1 ring-black/0 hover:ring-black/5
            `}
          >
          <img src="/image/SLA.png" className="mx-auto mb-4 w-90 h-90"></img> <h3 className="text-xl font-bold mb-3">Unlimited Data</h3> <h3 className="text-xl font-bold mb-3">SLA 99.9% Uptime</h3> <p className="text-gray-400"> Jaminan uptime 99.9% untuk paket bisnis. Kompensasi jika tidak memenuhi standar Service Level Agreement. </p> </div>
          </div>
      </div>
    </section>
  );
};

export default Keunggulan;